import {ToastrService} from 'ngx-toastr';
import {AuthService} from 'src/app/services/auth.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import {ClipboardService} from 'ngx-clipboard';
import exportFromJSON from 'export-from-json';
import {forEach} from '@angular/router/src/utils/collection';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-batch-jobs',
  templateUrl: './batch-jobs.component.html',
  styleUrls: ['./batch-jobs.component.css']
})
export class BatchJobsComponent implements OnInit {
  displayedColumns: String[] = ['application', '_id', 'status', 'noOfRecordsProcessed', 'noOfRecordsAccepted', 'noOfRecordsRejected', 'error', 'message'];
  batchJobs: any = [];
  noData: any;
  dataSource = new MatTableDataSource<any>(this.batchJobs);
  clientId: string;
  isLoading: boolean = false;
  isCopied = false;
  refreshTimer: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private authService: AuthService, private toasterService: ToastrService, private _clipboardService: ClipboardService) {
    this.clientId = localStorage.getItem('org_id');
  }

  ngOnInit() {
    this.getBatchJobs();
    this.refreshTimer = setInterval(() => {
      this.getBatchJobs();
    }, 60000);
  }

  getBatchJobs() {
    this.isLoading = true;
    this.authService.getBatchJobs(this.clientId).subscribe(
      (response: any) => {
        this.batchJobs = response.data;
        this.dataSource.data = this.batchJobs;
        this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));
        setTimeout(() => {
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.dataSource.filterPredicate = (data, filter: string) => {
            const accumulator = (currentTerm, key) => {
              return key === 'application' ? currentTerm + data.application.application_name : currentTerm + data[key];
            };
            const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
            const transformedFilter = filter.trim().toLowerCase();
            return dataStr.indexOf(transformedFilter) !== -1;
          };
          this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
              case 'application':
                return item.application.application_name;
              default:
                return item[property];
            }
          };
        }, 0);
        this.isLoading = false;
      },
      (error) => {
        this.toasterService.error(error.message);
        this.isLoading = false;
      }
    );
  }

  applyFilter(event: Event) {
    this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  closeAlert() {
    this.isCopied = false;
  }

  copyToClipboard(action) {
    this.isCopied = this._clipboardService.copyFromContent(action);
    setTimeout(() => {
      this.isCopied = false;
    }, 700);
  }

  ngOnDestroy() {
    clearInterval(this.refreshTimer);
  }

  generateReport(batchId) {
    let batchReport = this.batchJobs.find((batch) => batch._id == batchId);
    if (batchReport) {
      if (batchReport.error) {
        exportFromJSON({data: batchReport.message, fileName: 'Report', exportType: 'csv'});
      } else {
        exportFromJSON({data: [{result: 'Records uploaded successfully'}], fileName: 'Report', exportType: "csv"})
      }
    }
  }
}
